import { render, staticRenderFns } from "./ForgetPasswordPopup.vue?vue&type=template&id=7b15b5e2"
import script from "./ForgetPasswordPopup.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports